import Vue from 'vue'
import Vuex from 'vuex'
import loginModule from './modules/loginModule'
import menuModule from './modules/menuModule'
import tabsModule from './modules/tabsModule'
import settings from './modules/settings'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		
	},
	mutations: {
		
	},
	getters: {
		
	},
	actions: {},
	modules: {
		loginModule,
		menuModule,
		tabsModule,
		settings,
	}
})
